var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"main-button",class:{
    outline: _vm.outline,
    'primary-button': _vm.primary,
  },attrs:{"disabled":_vm.disabled,"data-progress":_vm.progress ? 'true' : 'false',"type":_vm.type,"data-color":_vm.color},on:{"click":_vm.changeEvent}},[_c('span',{staticClass:"main-button__label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"main-button__loader"},[_c('loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }